import React, { useState } from 'react';
import MaterialCheckbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

function SelectableIcon(props) {
  const checkBoxStyles = makeStyles(() => ({
    container: {
      width: props.width ? props.width : '130px',
      height: props.height ? props.height : '130px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      margin: 0,
    },
    shadow: {
      borderRadius: '24px',
      boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
      webkitBoxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
      mozBoxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
    },
  }));

  const formLabelStyles = makeStyles(() => ({
    label: {
      fontWeight: 'bold',
      fontSize: props.labelFontSize,
    },
  }));

  const checkboxClasses = checkBoxStyles();
  const formLabelClasses = formLabelStyles();
  const [checked, setChecked] = useState(props.checked);

  const onCheckboxChange = val => {
    if (props.onCheckboxChange) {
      props.onCheckboxChange(val.target.value, val.target.checked);
    }
  };

  return (
    <FormControlLabel
      className={clsx(
        checkboxClasses.container,
        checked && checkboxClasses.shadow
      )}
      control={
        <MaterialCheckbox
          checked={checked ? checked : false}
          id={props.value}
          value={props.value}
          name={props.type}
          icon={props.icon}
          checkedIcon={props.icon}
          onChange={e => onCheckboxChange(e)}
          onClick={e => setChecked(e.target.checked)}
        />
      }
      classes={formLabelClasses}
      label={props.label}
      labelPlacement={props.labelPlacement ? props.labelPlacement : 'bottom'}
    />
  );
}

export default SelectableIcon;
